export default __webpack_public_path__ + "static/media/woman-2-desktop.aaded1c9.jpg";